// extracted by mini-css-extract-plugin
export default {"DocumentFolderBreadCrumb":"_DocumentFolderBreadCrumb--ep2mN","WorkspaceIcon":"_WorkspaceIcon--PLoLw","FolderLinkText":"_FolderLinkText--KNU4V"};